import React, { useEffect, useState } from 'react'

import DataTable from '../../reusables/DataTable';
import { ColDef } from '@ag-grid-community/core';

import useGetDocuments from '../../../hooks/status_manager/useGetDocuments';

import { IDocuments } from '../../../types/status_manager';

interface IStatusManagerProps {
    applicantId: number;
}

export interface IStatusManagerList {
    [name: string]: boolean;
};

const documentsList = { passport: true, permit: true, visa: true }

const StatusManager = ({ applicantId }: IStatusManagerProps) => {

    const [documents, setDocuments] = useState<IDocuments | null>(null);
    const [accordion, setAccordion] = useState<IStatusManagerList>(documentsList);

    const { data: documentsData, isPending, isError } = useGetDocuments(applicantId);

    useEffect(() => {
        setDocuments(documentsData?.data ? documentsData.data : null);
    }, [documentsData]); //eslint-disable-line

    const passportColumns: ColDef[] = [
        { field: "passport_number", headerName: "Passport Number" },
        { field: "nationality", headerName: "Nationality" },
        { field: "submission_date", headerName: "Submission Date", valueFormatter: (params) => params.value ? new Date(params.value).toLocaleDateString() : "" },
        { field: "issued", headerName: "Issued", valueFormatter: (params) => params.value ? new Date(params.value).toLocaleDateString() : "" },
        { field: "expire", headerName: "Expire", valueFormatter: (params) => params.value ? new Date(params.value).toLocaleDateString() : "" },
        { field: "refused_date", headerName: "Refused Date", valueFormatter: (params) => params.value ? new Date(params.value).toLocaleDateString() : "" },
        { field: "status", headerName: "Status" },
        { field: "system_status", headerName: "System Status" },
        { field: "renewal_status", headerName: "Renewal Status" },
        { field: "renewal_comment", headerName: "Renewal Comment" },
    ]

    const visaColumns: ColDef[] = [
        { field: "passport_number", headerName: "Passport Number" },
        { field: "visa_number", headerName: "Visa Number" },
        { field: "type", headerName: "Type" },
        { field: "submission_date", headerName: "Submission Date", valueFormatter: (params) => params.value ? new Date(params.value).toLocaleDateString() : "" },
        { field: "issued", headerName: "Issued", valueFormatter: (params) => params.value ? new Date(params.value).toLocaleDateString() : "" },
        { field: "expire", headerName: "Expire", valueFormatter: (params) => params.value ? new Date(params.value).toLocaleDateString() : "" },
        { field: "refused_date", headerName: "Refused Date", valueFormatter: (params) => params.value ? new Date(params.value).toLocaleDateString() : "" },
        { field: "status", headerName: "Status" },
        { field: "system_status", headerName: "System Status" },
        { field: "renewal_status", headerName: "Renewal Status" },
        { field: "renewal_comment", headerName: "Renewal Comment" },
    ];

    const permitColumns: ColDef[] = [
        { field: "passport_number", headerName: "Passport Number" },
        { field: "permit_number", headerName: "Permit Number" },
        { field: "case_type", headerName: "Case Type" },
        { field: "permit_type_description", headerName: "Permit Type Description" },
        { field: "permit_type_code", headerName: "Permit Type Code" },
        { field: "permit_type_status", headerName: "Permit Type Status" },
        { field: "company", headerName: "Company" },
        { field: "submission_date", headerName: "Submission Date" },
        { field: "refused_date", headerName: "Refused Date", valueFormatter: (params) => params.value ? new Date(params.value).toLocaleDateString() : "" },
        { field: "issued", headerName: "Issued", valueFormatter: (params) => params.value ? new Date(params.value).toLocaleDateString() : "" },
        { field: "expire", headerName: "Expire", valueFormatter: (params) => params.value ? new Date(params.value).toLocaleDateString() : "" },
        { field: "status", headerName: "Status" },
        { field: "system_status", headerName: "System Status" },
        { field: "renewal_status", headerName: "Renewal Status" },
        { field: "renewal_comment", headerName: "Renewal Comment" },
    ];

    if (isPending) return <div className="imm_consultant__loading"><div className="imm_consultant__process_loader" />Loading...</div>
    if (isError) return <div className="imm_consultant__loading">Something went wrong. Please try again later.</div>

    return (
        <div className='imm_information__main'>
            <div className={accordion["passport"] ? "imm_information__accordion active" : "imm_information__accordion"}>
                <div className="imm_information__header" onClick={() => setAccordion({ ...accordion, passport: !accordion.passport })}>Passports</div>
                <div className="imm_information__content">
                    <div className="imm_information__data_table"><DataTable data={documents?.passports ?? []} columns={passportColumns} filter={false} /></div>
                </div>
            </div>

            <div className={accordion["visa"] ? "imm_information__accordion active" : "imm_information__accordion"}>
                <div className="imm_information__header" onClick={() => setAccordion({ ...accordion, visa: !accordion.visa })}>Visas</div>
                <div className="imm_information__content">
                    <div className="imm_information__data_table"><DataTable data={documents?.visas ?? []} columns={visaColumns} filter={false} /></div>
                </div>
            </div>

            <div className={accordion["permit"] ? "imm_information__accordion active" : "imm_information__accordion"}>
                <div className="imm_information__header" onClick={() => setAccordion({ ...accordion, permit: !accordion.permit })}>Permits</div>
                <div className="imm_information__content">
                    <div className="imm_information__data_table"><DataTable data={documents?.permits ?? []} columns={permitColumns} filter={false} /></div>
                </div>
            </div>
        </div>
    );
}
export default StatusManager;